import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronDown, ArrowLeft, Menu, X } from "lucide-react";

const MindshareNavbar = ({ showBackToLeaderboard = false }) => {
  const navigate = useNavigate();
  const [documentsOpen, setDocumentsOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="sticky top-0 z-50 flex justify-center pt-4 md:pt-9 px-4 md:px-0" style={{ background: "rgba(255, 255, 255, 0.02)", backdropFilter: "blur(10px)" }}>
      <nav 
        className="flex items-center w-full md:w-[91.5vw]"
        style={{
          height: "46px",
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(20px)",
          border: "0.5px solid #FFFFFF80",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: "16px",
        }}
      >
        {/* Logo and Text */}
        <a href="https://goldfishgold.com" className="flex items-center gap-2 md:gap-3 hover:opacity-80 transition-opacity">
          <img src="/ggbrLogoGold.svg" alt="Goldfish GGBR" className="h-4 md:h-5" />
          <span className="text-white text-xs md:text-sm font-medium">Goldfish GGBR</span>
        </a>

        {/* Desktop Navigation - Hidden on mobile */}
        <div className="hidden lg:flex items-center gap-14">
          <a href="https://goldfishgold.com/#advantages" target="_blank" rel="noreferrer" className="text-white hover:text-[#D4AF37] transition-colors" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "15px", lineHeight: "100%", letterSpacing: "-3%" }}>ADVANTAGES</a>
          <a href="https://goldfishgold.com/#architecture" target="_blank" rel="noreferrer" className="text-white hover:text-[#D4AF37] transition-colors" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "15px", lineHeight: "100%", letterSpacing: "-3%" }}>ARCHITECTURE</a>
          <a href="https://goldfishgold.com/about" target="_blank" rel="noreferrer" className="text-white hover:text-[#D4AF37] transition-colors" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "15px", lineHeight: "100%", letterSpacing: "-3%" }}>ABOUT</a>
          <div className="relative">
            <button 
              className="flex items-center gap-1 text-white hover:text-[#D4AF37] transition-colors"
              onClick={() => setDocumentsOpen(!documentsOpen)}
              style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "15px", lineHeight: "100%", letterSpacing: "-3%" }}
            >
              DOCUMENTS <ChevronDown size={12} />
            </button>
            {documentsOpen && (
              <div className="absolute top-full left-0 mt-2 py-4 px-6 rounded-lg" style={{ background: "#FFFFFF" }}>
                <a href="#" className="block py-2 text-[#1B2464] hover:text-[#D4AF37]" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px", lineHeight: "100%", letterSpacing: "-3%" }}>Whitepaper</a>
                <a href="#" className="block py-2 text-[#1B2464] hover:text-[#D4AF37]" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px", lineHeight: "100%", letterSpacing: "-3%" }}>Security</a>
                <a href="#" className="block py-2 text-[#1B2464] hover:text-[#D4AF37]" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px", lineHeight: "100%", letterSpacing: "-3%" }}>Environmental</a>
                <a href="#" className="block py-2 text-[#1B2464] hover:text-[#D4AF37]" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px", lineHeight: "100%", letterSpacing: "-3%" }}>Collateral</a>
                <a href="#" className="block py-2 text-[#1B2464] hover:text-[#D4AF37]" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px", lineHeight: "100%", letterSpacing: "-3%" }}>Support</a>
              </div>
            )}
          </div>
          <a href="https://goldfishgold.com/" target="_blank" rel="noreferrer" className="text-white hover:text-[#D4AF37] transition-colors" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px", lineHeight: "100%", letterSpacing: "-3%" }}>LEADERBOARD</a>
        </div>

        {/* Desktop Contact Us Button - Hidden on mobile */}
        <button 
          className="hidden lg:flex items-center transition-all h-full"
          style={{ 
            background: "#FFFFFF",
            border: "none",
            color: "#1B2464",
            paddingLeft: "20px",
            paddingRight: "20px",
            fontFamily: "Inter",
            fontWeight: 300,
            fontSize: "13px",
            lineHeight: "100%",
            letterSpacing: "-3%",
          }}
        >
          CONTACT US
        </button>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden flex items-center justify-center h-full px-4"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{ background: "transparent", border: "none" }}
        >
          {mobileMenuOpen ? (
            <X size={24} color="white" />
          ) : (
            <Menu size={24} color="white" />
          )}
        </button>
      </nav>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div 
          className="lg:hidden absolute top-full left-4 right-4 mt-2 py-4 px-4 z-50"
          style={{ 
            background: "rgba(27, 36, 100, 0.95)",
            backdropFilter: "blur(20px)",
            border: "0.5px solid #FFFFFF80",
          }}
        >
          <div className="flex flex-col gap-4">
            <a href="https://goldfishgold.com/#advantages" target="_blank" rel="noreferrer" className="text-white hover:text-[#D4AF37] transition-colors py-2" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px" }}>ADVANTAGES</a>
            <a href="https://goldfishgold.com/#architecture" target="_blank" rel="noreferrer" className="text-white hover:text-[#D4AF37] transition-colors py-2" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px" }}>ARCHITECTURE</a>
            <a href="https://goldfishgold.com/about" target="_blank" rel="noreferrer" className="text-white hover:text-[#D4AF37] transition-colors py-2" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px" }}>ABOUT</a>
            <a href="https://goldfishgold.com/" target="_blank" rel="noreferrer" className="text-white hover:text-[#D4AF37] transition-colors py-2" style={{ fontFamily: "Inter", fontWeight: 300, fontSize: "14px" }}>LEADERBOARD</a>
            <button 
              className="text-left py-2"
              style={{ 
                background: "#FFFFFF",
                color: "#1B2464",
                padding: "12px 16px",
                fontFamily: "Inter",
                fontWeight: 300,
                fontSize: "13px",
                border: "none",
              }}
            >
              CONTACT US
            </button>
          </div>
        </div>
      )}

      {/* Back to Leaderboard link - shown on Profile page */}
      {showBackToLeaderboard && (
        <button
          onClick={() => navigate('/mindshare')}
          className="absolute left-4 md:left-[4.25vw] top-[calc(100%+12px)] md:top-[calc(100%+16px)] flex items-center gap-2 text-white hover:text-[#D4AF37] transition-colors"
          style={{ fontFamily: "Inter", fontWeight: 400, fontSize: "13px" }}
        >
          <ArrowLeft size={14} />
          Back to Leaderboard
        </button>
      )}
    </div>
  );
};

export default MindshareNavbar;
